export const experienceData = [
  {
    id: 1,

    company: " OctaNet Services Pvt Ltd.",
    jobtitle: "Front-End Developer Intern",
    startYear: "April 2024",
    endYear: "July 2024",
  },
];
